"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamsIntegrationTreeView = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _TreeView = require("@/components/shared/TreeView");
var _TeamsIntegrationTreeViewModule = _interopRequireDefault(require("./TeamsIntegrationTreeView.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TeamsIntegrationTreeView = exports.TeamsIntegrationTreeView = function TeamsIntegrationTreeView() {
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    gap: 2,
    className: _TeamsIntegrationTreeViewModule["default"].container
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _TeamsIntegrationTreeViewModule["default"].title
  }, "Selected files"), /*#__PURE__*/_react["default"].createElement("span", {
    className: _TeamsIntegrationTreeViewModule["default"].description
  }, "Select an attachment to input details.")), /*#__PURE__*/_react["default"].createElement(_TreeView.TreeView, {
    showSelectAll: true,
    showDivider: true
  }));
};